import { useEffect, useState } from "react";
import { Edit, Plus, Trash2, X } from "lucide-react";
import AddStaffModal from "../AddStaffModal";
import { useSelector } from "react-redux";
import userApi from "../../../../api/userApi";
import { useNotification } from "../../../../hooks/useNotification";

export default function ManageStaffModal({
  isOpen,
  setIsOpen,
  staffs,
  setStaffs,
}) {
  const { addNotification } = useNotification();
  const auth = useSelector((state) => state.auth);

  const [isOpenAddStaffModal, setIsOpenAddStaffModal] = useState(false);
  const [editingStaff, setEditingStaff] = useState(null);

  const handleOpenAddStaffModal = (staff) => {
    if (staff) {
      setEditingStaff(staff);
    } else {
      setEditingStaff(null);
    }
    setIsOpenAddStaffModal(true);
  };

  const handleDeleteClick = async (staff) => {
    if (!window.confirm(`Bạn có muốn xoá nhân viên ${staff.name} không?`))
      return;
    const res = await userApi.updateById({
      _id: staff._id,
      isDelete: true,
    });
    if (res.status === 1) {
      await getStaffs();
      addNotification("Xoá thành công", res.status);
    } else addNotification(res.message, res.status);
  };

  const handleCloseClick = () => {
    setIsOpen(false);
  };

  const getStaffs = async () => {
    const res = await userApi.getByAccountId(auth.user.accountId);
    if (res.status === 1) setStaffs(res.data);
  };

  useEffect(() => {
    if (!auth.user.accountId || !isOpen) return;
    getStaffs();
  }, [auth.user, isOpen]);

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 text-black z-20">
          <div className="bg-white w-full max-w-4xl rounded-lg shadow-lg flex flex-col h-[80vh]">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-xl font-semibold">Quản lý nhân viên</h2>
              <button
                onClick={handleCloseClick}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Content */}
            <div className="flex flex-1 flex-col overflow-hidden">
              <div className="p-4">
                <button
                  onClick={() => handleOpenAddStaffModal()}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2 hover:bg-blue-700 transition-colors duration-200"
                >
                  <Plus className="w-4 h-4" />
                  Thêm
                </button>
              </div>
              <div className="flex-1 px-4 flex flex-col overflow-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        STT
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Tên
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        SĐT
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Username
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Mật khẩu
                      </th>
                      {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Trạng thái
                      </th> */}
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Hành động
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {staffs.map((staff, index) => (
                      <tr
                        key={staff._id}
                        className="hover:bg-gray-50 transition-colors duration-150"
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex items-center space-x-2">
                          <div className="h-7 w-7 rounded-full overflow-hidden">
                            {staff.avatar && (
                              <img
                                src={staff.avatar}
                                alt={staff.name}
                                className="h-full w-full object-cover"
                              />
                            )}
                          </div>
                          <span>{staff.name}</span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {staff.phone}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {staff.username}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {staff.password}
                        </td>
                        {/* <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              staff.status === "Đang làm việc"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                          >
                            {staff.status}
                          </span>
                        </td> */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <div className="flex gap-3">
                            <button
                              onClick={() => handleOpenAddStaffModal(staff)}
                              className="text-blue-600 hover:text-blue-900 transition-colors duration-200"
                            >
                              <Edit className="w-4 h-4" />
                            </button>
                            {staff._id !== auth.user._id &&
                              staff.role !== "super_admin" && (
                                <button
                                  onClick={() => handleDeleteClick(staff)}
                                  className="text-red-600 hover:text-red-900 transition-colors duration-200"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <AddStaffModal
            isOpen={isOpenAddStaffModal}
            setIsOpen={setIsOpenAddStaffModal}
            editingStaff={editingStaff}
            setEditingStaff={setEditingStaff}
            getStaffs={getStaffs}
          />
        </div>
      )}
    </div>
  );
}
